<template>
    <div class="relative font-sans antialiased">
        <div class="absolute pin-t pin-r mt-10 mr-10" v-if="patientError">
            <div class="bg-red-light shadow border border-red-light text-white px-4 py-3 rounded relative">
                <span class="icon mr-1 text-lg"><i class="mdi mdi-alert-circle-outline"></i></span>
                <span class="font-semibold" v-text="patientError"></span>
            </div>
        </div>
        <router-view class="min-h-(screen-footer-sm) md:min-h-(screen-footer-md)"></router-view>

        <footer id="footer" class="py-12 bg-footer text-white">
            <div class="max-w-md mx-auto px-6">
                <div class="flex items-top flex-wrap md:justify-between">
                    <div class="w-full md:w-auto flex flex-col justify-center md:justify-start">
                        <div class="flex justify-center md:justify-start mb-4">
                            <router-link :to="{path: '/'}"><img src="/static/img/tooddoc.png" alt="Tooddoc" class="h-4"></router-link>
                        </div>
                        <div class="flex justify-center md:flex-col md:justify-start mb-8 md:mb-0">
                            <a :href="$t('play_store_uri')" target="_blank" class="transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0 md:mb-4">
                                <img src="/static/img/play_store_hover.svg" alt="Get it on Google Play" class="h-10">
                            </a>
                            <a :href="$t('app_store_uri')" target="_blank" class="transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0">
                                <img src="/static/img/app_store_hover.svg" alt="Get it on the App Store" class="h-10">
                            </a>
                        </div>
                    </div>
                    <div class="w-full md:w-auto flex md:flex-col items-center justify-center md:justify-start md:items-start md:text-left mb-8 md:mb-0">
                        <a :href="$t('public_site_uri')" class="text-white hover:underline text-xs font-semibold md:mb-4">{{ $t('public_site_label') }}</a>
                        <span class="mx-2 md:hidden">-</span>
                        <a :href="$t('contact_uri')" class="text-white hover:underline text-xs font-semibold md:mb-4">{{ $t('contact_label') }}</a>
                        <span class="mx-2 md:hidden">-</span>
                        <router-link :to="{name: 'doctor.dashboard'}" class="text-white hover:underline text-xs font-semibold md:mb-4">{{ $t('i_am_a_dentist_label') }}</router-link>
                    </div>
                    <div class="hidden md:flex w-auto flex-col text-left">
                        <a :href="$t('terms_uri')" class="text-white hover:underline text-xs font-semibold mb-4">{{ $t('terms_label') }}</a>
                        <a :href="$t('privacy_policy_uri')" class="text-white hover:underline text-xs font-semibold mb-4">{{ $t('privacy_policy_label') }}</a>
                        <a :href="$t('cookie_policy_uri')" class="text-white hover:underline text-xs font-semibold mb-4">{{ $t('cookie_policy_label') }}</a>
                    </div>
                    <div class="flex md:hidden w-full md:w-auto items-center justify-center text-center">
                        <a :href="$t('terms_uri')" class="text-white hover:underline text-xs font-semibold">{{ $t('terms_label') }}</a>
                        <span class="mx-2">-</span>
                        <a :href="$t('privacy_policy_uri')" class="text-white hover:underline text-xs font-semibold">{{ $t('privacy_policy_label') }}</a>
                        <span class="mx-2">-</span>
                        <a :href="$t('cookie_policy_uri')" class="text-white hover:underline text-xs font-semibold">{{ $t('cookie_policy_label') }}</a>
                    </div>
                </div>
            </div>
        </footer>

        <div class="fixed pin-x pin-b mb-4" v-if="showCookieNotification">
            <div class="flex items-center justify-between rounded bg-blue text-white max-w-sm mx-auto px-4 py-3">
                <span v-text="$t('cookie_notification')"></span>
                <button class="text-blue-lighter hover:text-blue-lightest" @click="consentCookies()"><span class="icon"><i class="mdi mdi-close"></i></span></button>
            </div>
        </div>

        <!-- <div :class="isLoading ? 'flex' : 'hidden'" class="text-5xl h-screen w-full items-center justify-center text-grey"><span class="icon"><i class="mdi mdi-loading spin"></i></span></div> -->
    </div>
</template>

<script>
    import { store } from '@/store'
    import { db } from '@/firebase'
    import helpers from '@/mixins/helpers'

    import patientRepository from '@/data/PatientRepository'

    export default {
        name: 'PatientLayout',

        mixins: [helpers],

        data() {
            return {
                consentForCookies: false
            }
        },

        mounted () {
            this.consentForCookies = this.hasGivenConsentForCookies()

            let language = this.$router.currentRoute.query.lang || localStorage.getItem('language') || this.frontLanguage || 'en'
            let locale = localStorage.getItem('locale') || 'en'

            if (language !== this.frontLanguage || language !== locale.slice(0, 2)) {
                db.collection('languages')
                    .where('shortCode', '==', language)
                    .get()
                    .then(querySnapshot => {
                        if (querySnapshot.size >= 1) {
                            let language = querySnapshot.docs[0].data()
                            this.setLocale(language.code)
                            this.$store.dispatch('setFrontLanguage', language.shortCode)
                        }
                    })
            } else {
                this.setLocale(locale)
                this.$store.dispatch('setFrontLanguage', language)
            }
        },

        watch: {
            preventBodyScroll (newVal, oldVal) {
                if (newVal === true) {
                    document.body.classList.add('overflow-hidden')
                } else {
                    document.body.classList.remove('overflow-hidden')
                }
            }
        }
    }
</script>

<style src="../assets/scss/patient.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/layouts/PatientLayout.vue